<section *ngIf="loading">
  <h2>Loading...</h2>
  <mat-progress-bar mode="indeterminate" color="primary" aria-label="Loading..."></mat-progress-bar>
</section>

<div class="firm-edit-dialog" [ngStyle]="{'--entity-color' : uiData.firm.color}" *ngIf="!loading && firm">
  <mat-card [style.background-color]="uiData.firm.color">
    <h2 class="noMarginHeader">
      <mat-icon>{{uiData.firm.icon}}</mat-icon> {{ firm.name || 'Firm' }}
    </h2>
  </mat-card>

  <div class="scroll-container">
    <br />
    <div fxLayout="column">
      <mat-card>
        <mat-tab-group dynamicHeight mat-align-tabs="center" mat-stretch-tabs="true" [selectedIndex]="selectedTabIndex" (selectedIndexChange)="onTabIndexChange($event)">
          <mat-tab>
            <ng-template mat-tab-label>
              Firm Information
            </ng-template>
            <ng-container>
              <mat-card class="custom-mat-card">
                <mat-card-title>
                  <div>
                    <span fxFlex>Firm Information</span>
                  </div>
                </mat-card-title>
                <mat-card-content>
                  <div fxLayout="column" fxLayoutGap="8px">
                    <form [formGroup]="firmForm">
                      <div fxLayout="column" fxFlex>
                        <div fxLayout="row" fxLayout.lt-md="column" fxLayoutGap="8px">
                          <div fxLayout="column" fxLayoutGap="8px" fxFlex="50">
                            <mat-form-field>
                              <input matInput placeholder="Firm Name" formControlName="name">
                            </mat-form-field>
                            <mat-form-field>
                              <input matInput placeholder="Certification Number" formControlName="certificationNumber" readonly>
                            </mat-form-field>
                            <mat-form-field>
                              <mat-label>Services Available</mat-label>
                              <mat-select formControlName="servicesAvailable">
                                <mat-option *ngFor="let status of getFirmServiceForTypeValues()" [value]="status">{{ status }}</mat-option>
                              </mat-select>
                            </mat-form-field>
                            <span><strong>Private Firm</strong></span>
                            <mat-checkbox formControlName="isPrivate">
                              <span class="mat-checkbox-label">
                                Private Firm
                              </span>
                            </mat-checkbox>
                          </div>
                          <div fxLayout="column" fxLayoutGap="8px" fxFlex="50">
                            <mat-form-field>
                              <input matInput placeholder="Property Management License #" formControlName="propertyManagementLicense">
                            </mat-form-field>
                            <mat-form-field>
                              <input matInput placeholder="Construction Contractors Board #" formControlName="ccb">
                            </mat-form-field>
                            <mat-form-field>
                              <input matInput [matDatepicker]="dobPicker" placeholder="Construction Contractors Board Expiration" formControlName="ccbExpirationDate" (focus)="dobPicker.open()">
                              <mat-datepicker-toggle matSuffix [for]="dobPicker"></mat-datepicker-toggle>
                              <mat-datepicker #dobPicker></mat-datepicker>
                            </mat-form-field>
                            <span><strong>Firm Inactive</strong></span>
                            <mat-checkbox formControlName="inactive">
                              <span class="mat-checkbox-label">
                                Firm Inactive
                              </span>
                            </mat-checkbox>
                          </div>
                        </div>
                        <div style="margin-top: 20px;" fxLayout="column" fxFlex="100">
                          <span><strong>Firm Coverage</strong></span>
                          <mat-form-field>
                            <input matInput placeholder="Firm Service Coverage Area" formControlName="coverage">
                          </mat-form-field>
                        </div>
                      </div>
                    </form>
                  </div>
                </mat-card-content>
              </mat-card>
            </ng-container>
          </mat-tab>

          <mat-tab>
            <ng-template mat-tab-label>
              <mat-icon>{{uiData.contact.icon}}</mat-icon> &nbsp; Contact Information({{addressTableData.length + contactInformationTableData.length}})
            </ng-template>
            <ng-container>
              <div fxLayout="row" fxLayout.lt-md="column" fxFlex>
                <mat-card class="custom-mat-card" fxFlex="100">
                  <mat-accordion multi>
                    <mat-expansion-panel>
                      <mat-expansion-panel-header>
                        <mat-panel-title>
                          <span><h4>Addresses - {{addressTableData.length}}</h4></span>
                        </mat-panel-title>
                      </mat-expansion-panel-header>
                      <div fxLayout="column">
                        <div [fxFlex.gt-sm]="100" [fxFlex]="100" class="matero-col" style="overflow-x: auto;">
                          <div fxLayout="row wrap" class="matero-row" fxLayoutAlign="space-between start">
                            <div fxLayoutGap="5px">
                              <strong class="noMarginHeader">Results ({{addressFilteredTableData.length}})</strong>
                              <mat-form-field style="width:200px;">
                                <input (keyup)="filterAddressTable()" placeholder="Filter Results" [(ngModel)]="filterAddressString" matInput />
                              </mat-form-field>

                              <mat-form-field style="width:150px">
                                <mat-select multiple placeholder="Filter Address Type" [formControl]="filterAddressType" (selectionChange)="filterAddressTable()">
                                  <mat-option *ngFor="let type of addressTypeList" [value]="type">
                                    {{ type }}
                                  </mat-option>
                                </mat-select>
                              </mat-form-field>

                              <mat-form-field style="width:150px">
                                <mat-select multiple placeholder="Filter Physical" [formControl]="filterAddressPhysical" (selectionChange)="filterAddressTable()">
                                  <mat-option *ngFor="let type of addressBoolList" [value]="type">
                                    {{ type }}
                                  </mat-option>
                                </mat-select>
                              </mat-form-field>

                              <mat-form-field style="width:150px">
                                <mat-select multiple placeholder="Filter Mailing" [formControl]="filterAddressMailing" (selectionChange)="filterAddressTable()">
                                  <mat-option *ngFor="let type of addressBoolList" [value]="type">
                                    {{ type }}
                                  </mat-option>
                                </mat-select>
                              </mat-form-field>
                            </div>
                            <div>
                              <button mat-raised-button color="primary" (click)="editAddressTableEntry(null)">
                                <mat-icon>add</mat-icon> Add Address
                              </button>
                            </div>
                          </div>

                          <br />

                          <mat-table [dataSource]="addressDataSource" matSort #AddressTableSort="matSort" class="mat-elevation-z8" style="overflow-x: auto;">
                            <mat-header-row fxLayout="row" fxLayout.lt-md="column" *matHeaderRowDef="addressTableColumns"></mat-header-row>
                            <mat-row fxLayout="row" fxLayout.lt-md="column" *matRowDef="let row; columns: addressTableColumns" (click)="editAddressTableEntry(row); $event.stopPropagation()"></mat-row>

                            <ng-container *ngFor="let cellData of addressTableFormat; let i = index" [matColumnDef]="cellData.columnName">
                              <mat-header-cell mat-sort-header [fxFlex]="cellData.size" *matHeaderCellDef>{{ cellData.displayName }}</mat-header-cell>
                              <mat-cell *matCellDef="let row" [fxFlex]="cellData.size" matTooltip="{{row[cellData.columnName]}}">
                                <ng-container [ngSwitch]="cellData.type">
                                  <ng-container *ngSwitchCase="'date'">
                                    {{ row[cellData.columnName] | date: 'MM/dd/yyyy' }}
                                  </ng-container>
                                  <ng-container *ngSwitchCase="'bool'">
                                    <mat-checkbox [checked]="row[cellData.columnName]" (click)="$event.stopPropagation()" (change)="addressCheckboxChange(row, cellData.columnName)"></mat-checkbox>
                                  </ng-container>
                                  <ng-container *ngSwitchDefault>
                                    {{ displayLimit(row[cellData.columnName], cellData.size) }}
                                  </ng-container>
                                </ng-container>
                              </mat-cell>
                            </ng-container>

                            <ng-container matColumnDef="actions">
                              <mat-header-cell *matHeaderCellDef fxFlex="7">Actions</mat-header-cell>
                              <mat-cell *matCellDef="let row" fxFlex="7">
                                <div style="display: flex; justify-content: space-between; width: 100px;">
                                  <button mat-icon-button color="warn" style="width: 50px;" (click)="deleteAddressEntry(row); $event.stopPropagation()">
                                    <mat-icon>delete</mat-icon>
                                  </button>
                                </div>
                              </mat-cell>
                            </ng-container>
                          </mat-table>

                          <br />
                          <mat-paginator [pageSize]="addressTablePageSize" [pageSizeOptions]="[5, 10, 50, addressFilteredTableData.length]" #AddressTablePaginator="matPaginator" showFirstLastButtons></mat-paginator>
                        </div>
                      </div>
                    </mat-expansion-panel>

                    <mat-expansion-panel>
                      <mat-expansion-panel-header>
                        <mat-panel-title>
                          <span><h4>Contact Information - {{contactInformationTableData.length}}</h4></span>
                        </mat-panel-title>
                      </mat-expansion-panel-header>
                      <div fxLayout="column">
                        <div [fxFlex.gt-sm]="100" [fxFlex]="100" class="matero-col" style="overflow-x: auto;">
                          <div fxLayout="row wrap" class="matero-row" fxLayoutAlign="space-between start">
                            <div fxLayoutGap="5px">
                              <strong class="noMarginHeader">Results ({{contactInformationFilteredTableData.length}})</strong>
                              <mat-form-field style="width:200px;">
                                <input (keyup)="filterContactInformationTable()" placeholder="Filter Results" [(ngModel)]="filterContactInformationString" matInput />
                              </mat-form-field>

                              <mat-form-field style="width:150px">
                                <mat-select multiple placeholder="Filter Contact Type" [formControl]="filterContactInformationType" (selectionChange)="filterContactInformationTable()">
                                  <mat-option *ngFor="let type of contactInformationTypeList" [value]="type">
                                    {{ type }}
                                  </mat-option>
                                </mat-select>
                              </mat-form-field>
                            </div>
                            <div>
                              <button mat-raised-button color="primary" (click)="editContactInformationTableEntry(null)">
                                <mat-icon>add</mat-icon> Add Contact Information
                              </button>
                            </div>
                          </div>

                          <br />

                          <mat-table [dataSource]="contactInformationDataSource" matSort #ContactInformationTableSort="matSort" class="mat-elevation-z8" style="overflow-x: auto;">
                            <mat-header-row fxLayout="row" fxLayout.lt-md="column" *matHeaderRowDef="contactInformationTableColumns"></mat-header-row>
                            <mat-row fxLayout="row" fxLayout.lt-md="column" *matRowDef="let row; columns: contactInformationTableColumns" (click)="editContactInformationTableEntry(row); $event.stopPropagation()"></mat-row>

                            <ng-container *ngFor="let cellData of contactInformationTableFormat; let i = index" [matColumnDef]="cellData.columnName">
                              <mat-header-cell mat-sort-header [fxFlex]="cellData.size" *matHeaderCellDef>{{ cellData.displayName }}</mat-header-cell>
                              <mat-cell *matCellDef="let row" [fxFlex]="cellData.size" matTooltip="{{row[cellData.columnName]}}">
                                <ng-container [ngSwitch]="cellData.type">
                                  <ng-container *ngSwitchCase="'date'">
                                    {{ row[cellData.columnName] | date: 'MM/dd/yyyy' }}
                                  </ng-container>
                                  <ng-container *ngSwitchCase="'bool'">
                                    <mat-checkbox [checked]="row[cellData.columnName]" disabled></mat-checkbox>
                                  </ng-container>
                                  <ng-container *ngSwitchDefault>
                                    {{ displayLimit(row[cellData.columnName], cellData.size) }}
                                  </ng-container>
                                </ng-container>
                              </mat-cell>
                            </ng-container>

                            <ng-container matColumnDef="actions">
                              <mat-header-cell *matHeaderCellDef fxFlex="7">Actions</mat-header-cell>
                              <mat-cell *matCellDef="let row" fxFlex="7">
                                <div style="display: flex; justify-content: space-between; width: 100px;">
                                  <button mat-icon-button color="warn" style="width: 50px;" (click)="deleteContactInformationEntry(row); $event.stopPropagation()">
                                    <mat-icon>delete</mat-icon>
                                  </button>
                                </div>
                              </mat-cell>
                            </ng-container>
                          </mat-table>

                          <br />
                          <mat-paginator [pageSize]="contactInformationTablePageSize" [pageSizeOptions]="[5, 10, 50, contactInformationFilteredTableData.length]" #ContactInformationTablePaginator="matPaginator" showFirstLastButtons></mat-paginator>
                        </div>
                      </div>
                    </mat-expansion-panel>
                  </mat-accordion>
                </mat-card>
              </div>
            </ng-container>
          </mat-tab>

          <mat-tab>
            <ng-template mat-tab-label>
              <mat-icon>{{uiData.certificate.icon}}</mat-icon> &nbsp; Certificates ({{firmFilteredCertificates.length}})
            </ng-template>
            <ng-container>
              <mat-card class="custom-mat-card">
                <mat-card-title>
                  <div fxLayout="row" fxLayout.lt-lg="column">
                    <span fxFlex>Certificates</span>
                  </div>
                </mat-card-title>
                <mat-card-content>
                  <div fxLayout="column">
                    <div [fxFlex.gt-sm]="100" [fxFlex]="100" class="matero-col" style="overflow-x: auto;">
                      <div fxLayout="row wrap" class="matero-row" fxLayoutAlign="space-between start">
                        <div fxLayout="column">
                          <strong class="noMarginHeader">Results ({{firmFilteredCertificates.length}})</strong>
                          <div fxLayout="row" fxLayout.lt-md="column">
                            <mat-form-field style="width:200px;">
                              <input placeholder="Filter Certificates" type="text" (input)="updateCertificateDebounceString($event)" matInput />
                            </mat-form-field>
                            &nbsp;&nbsp;
                            <mat-form-field style="width:200px;">
                              <mat-label>Filter Certificate Stage</mat-label>
                              <mat-select (selectionChange)="filterCertificateTable()" [formControl]="certificateStageFilter">
                                <mat-option value="Initial">Initial</mat-option>
                                <mat-option value="Refresher">Refresher</mat-option>
                                <mat-option value="Both">Both</mat-option>
                              </mat-select>
                            </mat-form-field>
                            &nbsp;&nbsp;
                            <mat-checkbox [(ngModel)]="showHistory" (change)="filterCertificateTable()">Show Historical</mat-checkbox>
                          </div>
                        </div>
                      </div>

                      <br />

                      <mat-table [dataSource]="certificatesDataSource" matSort #CertificateTableSort="matSort" class="mat-elevation-z8" style="overflow-x: auto;">
                        <mat-header-row fxLayout="row" [fxHide.lt-md]="true" fxLayout.lt-md="column" *matHeaderRowDef="certificateTable.layout.columns.concat('actions')"></mat-header-row>
                        <mat-row fxLayout="row" fxLayout.lt-md="column" *matRowDef="let row; columns: certificateTable.layout.columns.concat('actions')" (click)="openCertificateAction(row); $event.stopPropagation()" [ngStyle]="{'--hover-bg-color': sharedService.hoverBackgroundColor}"></mat-row>

                        <ng-container *ngFor="let cellData of certificateTable.layout.container; let i = index" [matColumnDef]="cellData.columnName">
                          <mat-header-cell [fxFlex]="cellData.size" mat-sort-header *matHeaderCellDef [ngStyle]=" isMobile ? {'width': '100%', 'padding-left': '5px'} : {}">{{ cellData.displayName }}</mat-header-cell>
                          <mat-cell *matCellDef="let row" [fxFlex]="cellData.size" [ngStyle]=" isMobile ? {'width': '100%', 'padding-left': '5px'} : {}" matTooltip="{{row[cellData.columnName]}}" [ngClass]="cellData.columnName === 'requestStatus' ? getStaffStatusClass(row) : ''">
                            <ng-container [ngSwitch]="cellData.type">
                              <ng-container *ngSwitchCase="'date'">
                                <div *ngIf="isMobile" fxLayout="row">
                                  <span><strong>{{cellData.displayName}}: </strong></span> &nbsp;
                                  <span>{{(row[cellData.columnName] | date:'MM/dd/yyyy')}}</span>
                                </div>
                                <div *ngIf="!isMobile">
                                  {{(row[cellData.columnName] | date:'MM/dd/yyyy')}}
                                </div>
                              </ng-container>
                              <ng-container *ngSwitchCase="'bool'">
                                <div *ngIf="isMobile" fxLayout="row">
                                  <span><strong>{{cellData.displayName}}: </strong></span> &nbsp;
                                  <mat-checkbox [(ngModel)]="row[cellData.columnName]" [disabled]="true"></mat-checkbox>
                                </div>
                                <div *ngIf="!isMobile">
                                  <mat-checkbox [(ngModel)]="row[cellData.columnName]" [disabled]="true"></mat-checkbox>
                                </div>
                              </ng-container>
                              <ng-container *ngSwitchDefault>
                                <div *ngIf="isMobile" fxLayout="row">
                                  <span><strong>{{ cellData.displayName }}: </strong></span> &nbsp;
                                  <span>{{ displayLimit(row[cellData.columnName], cellData.size) }}</span>
                                </div>
                                <div *ngIf="!isMobile">
                                  {{displayLimit(row[cellData.columnName], cellData.size)}}
                                </div>
                              </ng-container>
                            </ng-container>
                          </mat-cell>
                        </ng-container>

                        <ng-container matColumnDef="actions">
                          <mat-header-cell fxFlex="12" *matHeaderCellDef [ngStyle]=" isMobile ? {'width': '100%', 'padding-left': '5px'} : {}">Actions</mat-header-cell>
                          <mat-cell fxFlex="12" *matCellDef="let row" [ngStyle]=" isMobile ? {'width': '100%', 'padding-left': '5px'} : {}">
                            <div *ngIf="isMobile" fxLayoutGap="2px" fxLayout="row" style="display: flex; justify-content: space-between; align-items: center;">
                              <span><strong>Action: </strong></span> &nbsp;&nbsp;
                              <button mat-raised-button color="primary" style="width: 70px;" (click)="openCertificateAction(row); $event.stopPropagation()">
                                {{ getCertificateActionLabel(row) }}
                              </button>
                            </div>
                            <div fxLayout="row" fxLayoutGap="2px" *ngIf="!isMobile">
                              <button mat-raised-button color="primary" style="width: 70px; padding: 1px;" (click)="openCertificateAction(row); $event.stopPropagation()">
                                {{ getCertificateActionLabel(row) }}
                              </button>
                            </div>
                          </mat-cell>
                        </ng-container>
                      </mat-table>

                      <br />
                      <mat-paginator [pageSize]="certificateTablePageSize" [pageSizeOptions]="[5, 10, 50, firmFilteredCertificates.length]" #CertificateTablePaginator="matPaginator" showFirstLastButtons></mat-paginator>
                    </div>
                  </div>
                </mat-card-content>
              </mat-card>
            </ng-container>
          </mat-tab>

          <mat-tab>
            <ng-template mat-tab-label>
              <mat-icon>description</mat-icon> &nbsp; Applications ({{visibleApplicationCount}})
            </ng-template>
            <ng-container>
              <mat-card class="custom-mat-card">
                <mat-card-title>
                  <div fxLayout="row">
                    <span fxFlex>Applications</span>
                  </div>
                </mat-card-title>
                <mat-card-content>
                  <app-firm-application-list [firmId]="firm.id" [isEmbedded]="true" (countChanged)="onApplicationCountChanged($event)"></app-firm-application-list>
                </mat-card-content>
              </mat-card>
            </ng-container>
          </mat-tab>

          <mat-tab>
            <ng-template mat-tab-label>
              <mat-icon>{{uiData.credential.icon}}</mat-icon> &nbsp; Credentials ({{firmFilteredCredentials.length}})
            </ng-template>
            <ng-container>
              <mat-card class="custom-mat-card">
                <mat-card-title>
                  <div fxLayout="row" fxLayout.lt-lg="column">
                    <span fxFlex>Credentials</span>
                  </div>
                </mat-card-title>
                <mat-card-content>
                  <div fxLayout="column">
                    <div [fxFlex.gt-sm]="100" [fxFlex]="100" class="matero-col" style="overflow-x: auto;">
                      <div fxLayout="row wrap" class="matero-row" fxLayoutAlign="space-between start">
                        <div fxLayout="column">
                          <strong class="noMarginHeader">Results ({{firmFilteredCredentials.length}})</strong>
                          <div fxLayout="row">
                            <mat-form-field style="width:200px;">
                              <input placeholder="Filter Results" type="text" (input)="updateCredentialDebounceString($event)" matInput />
                            </mat-form-field>
                          </div>
                        </div>
                        <div>
                          <button mat-raised-button color="primary" (click)="editCredential(null)">
                            <mat-icon>add</mat-icon> Add Credential
                          </button>
                        </div>
                      </div>

                      <br />

                      <mat-table [dataSource]="credentialDataSource" matSort #CredentialTableSort="matSort" class="mat-elevation-z8" style="overflow-x: auto;">
                        <mat-header-row fxLayout="row" [fxHide.lt-md]="true" fxLayout.lt-md="column" *matHeaderRowDef="credentialTable.layout.columns.concat('actions')"></mat-header-row>
                        <mat-row fxLayout="row" fxLayout.lt-md="column" *matRowDef="let row; columns: credentialTable.layout.columns.concat('actions')" (click)="editCredential(row); $event.stopPropagation()"></mat-row>

                        <ng-container *ngFor="let cellData of credentialTable.layout.container; let i = index" [matColumnDef]="cellData.columnName">
                          <mat-header-cell [fxFlex]="cellData.size" mat-sort-header *matHeaderCellDef [ngStyle]="isMobile ? {'width': '100%', 'padding-left': '5px'} : {}">{{ cellData.displayName }}</mat-header-cell>
                          <mat-cell *matCellDef="let row" [fxFlex]="cellData.size" [ngStyle]="isMobile ? {'width': '100%', 'padding-left': '5px'} : {}" [matTooltip]="getCredentialCellTooltip(row, cellData)">
                            <ng-container *ngIf="cellData.columnName === 'staffIds'; else otherCases">
                              <div *ngIf="row[cellData.columnName] && row[cellData.columnName].length > 0">
                                <div *ngIf="isMobile" fxLayout="row">
                                  <span><strong>{{cellData.displayName}}: </strong></span> &nbsp;
                                  <span>{{row[cellData.columnName][0]?.display}}</span>
                                </div>
                                <div *ngIf="!isMobile">
                                  {{row[cellData.columnName][0]?.display}}
                                </div>
                              </div>
                            </ng-container>
                            <ng-template #otherCases>
                              <ng-container [ngSwitch]="cellData.type">
                                <ng-container *ngSwitchCase="'date'">
                                  <div *ngIf="isMobile" fxLayout="row">
                                    <span><strong>{{cellData.displayName}}: </strong></span> &nbsp;
                                    <span>{{(row[cellData.columnName] | date:'MM/dd/yyyy')}}</span>
                                  </div>
                                  <div *ngIf="!isMobile">
                                    {{(row[cellData.columnName] | date:'MM/dd/yyyy')}}
                                  </div>
                                </ng-container>
                                <ng-container *ngSwitchCase="'bool'">
                                  <div *ngIf="isMobile" fxLayout="row">
                                    <span><strong>{{cellData.displayName}}: </strong></span> &nbsp;
                                    <mat-checkbox [(ngModel)]="row[cellData.columnName]" [disabled]="true"></mat-checkbox>
                                  </div>
                                  <div *ngIf="!isMobile">
                                    <mat-checkbox [(ngModel)]="row[cellData.columnName]" [disabled]="true"></mat-checkbox>
                                  </div>
                                </ng-container>
                                <ng-container *ngSwitchDefault>
                                  <div *ngIf="isMobile" fxLayout="row">
                                    <span><strong>{{ cellData.displayName }}: </strong></span> &nbsp;
                                    <span>{{ displayLimit(row[cellData.columnName], cellData.size) }}</span>
                                  </div>
                                  <div *ngIf="!isMobile">
                                    {{displayLimit(row[cellData.columnName], cellData.size)}}
                                  </div>
                                </ng-container>
                              </ng-container>
                            </ng-template>
                          </mat-cell>
                        </ng-container>

                        <ng-container matColumnDef="actions">
                          <mat-header-cell *matHeaderCellDef fxFlex="7" [ngStyle]="isMobile ? {'width': '100%', 'padding-left': '5px'} : {}">Action</mat-header-cell>
                          <mat-cell *matCellDef="let row" fxFlex="7" [ngStyle]="isMobile ? {'width': '100%', 'padding-left': '5px'} : {}">
                            <div *ngIf="isMobile" fxLayout="row" style="display: flex; justify-content: space-between; align-items: center;">
                              <span><strong>Action: </strong></span>
                              <button mat-icon-button color="warn" aria-label="Delete Credential" (click)="deleteCredential(row); $event.stopPropagation()">
                                <mat-icon>delete</mat-icon>
                              </button>
                            </div>
                            <div *ngIf="!isMobile">
                              <button mat-icon-button color="warn" aria-label="Delete Credential" (click)="deleteCredential(row); $event.stopPropagation()">
                                <mat-icon>delete</mat-icon>
                              </button>
                            </div>
                          </mat-cell>
                        </ng-container>
                      </mat-table>

                      <br />
                      <mat-paginator [pageSize]="credentialTablePageSize" [pageSizeOptions]="[5, 10, 50, firmFilteredCredentials.length]" #CredentialTablePaginator="matPaginator" showFirstLastButtons></mat-paginator>
                    </div>
                  </div>
                </mat-card-content>
              </mat-card>
            </ng-container>
          </mat-tab>

          <mat-tab>
            <ng-template mat-tab-label>
              <mat-icon>{{uiData.staff.icon}}</mat-icon> &nbsp; Staff ({{firmFilteredStaff.length}})
            </ng-template>
            <ng-container>
              <mat-card class="custom-mat-card">
                <mat-card-title>
                  <div fxLayout="row" fxLayout.lt-lg="column">
                    <span fxFlex>Staff</span>
                  </div>
                </mat-card-title>
                <mat-card-content>
                  <div fxLayout="column">
                    <div [fxFlex.gt-sm]="100" [fxFlex]="100" class="matero-col" style="overflow-x: auto;">
                      <div fxLayout="row wrap" class="matero-row" fxLayoutAlign="space-between start">
                        <div fxLayout="column">
                          <strong class="noMarginHeader">Results ({{firmFilteredStaff.length}})</strong>
                          <div fxLayout="row">
                            <mat-form-field style="width:200px;">
                              <input placeholder="Filter Results" type="text" (input)="updateStaffDebounceString($event)" matInput />
                            </mat-form-field>
                          </div>
                        </div>
                        <div>
                          <button mat-raised-button color="primary" (click)="openAddStaffRequestDialog()">
                            <mat-icon>add</mat-icon> Add Staff
                          </button>
                        </div>
                      </div>

                      <br />

                      <mat-table [dataSource]="staffDataSource" matSort #StaffTableSort="matSort" class="mat-elevation-z8" style="overflow-x: auto;">
                        <mat-header-row fxLayout="row" [fxHide.lt-md]="true" fxLayout.lt-md="column" *matHeaderRowDef="staffTable.layout.columns.concat('actions')"></mat-header-row>
                        <mat-row fxLayout="row" fxLayout.lt-md="column" *matRowDef="let row; columns: staffTable.layout.columns.concat('actions')" [ngClass]="getStaffRowClass(row)"></mat-row>

                        <ng-container *ngFor="let cellData of staffTable.layout.container; let i = index" [matColumnDef]="cellData.columnName">
                          <mat-header-cell [fxFlex]="cellData.size" mat-sort-header *matHeaderCellDef [ngStyle]=" isMobile ? {'width': '100%', 'padding-left': '5px'} : {}">{{ cellData.displayName }}</mat-header-cell>
                          <mat-cell *matCellDef="let row" [fxFlex]="cellData.size" [ngStyle]=" isMobile ? {'width': '100%', 'padding-left': '5px'} : {}" matTooltip="{{row[cellData.columnName]}}">
                            <ng-container [ngSwitch]="cellData.type">
                              <ng-container *ngSwitchCase="'date'">
                                <div *ngIf="isMobile" fxLayout="row">
                                  <span><strong>{{cellData.displayName}}: </strong></span> &nbsp;
                                  <span>{{(row[cellData.columnName] | date:'MM/dd/yyyy')}}</span>
                                </div>
                                <div *ngIf="!isMobile">
                                  {{(row[cellData.columnName] | date:'MM/dd/yyyy')}}
                                </div>
                              </ng-container>
                              <ng-container *ngSwitchCase="'bool'">
                                <div *ngIf="isMobile" fxLayout="row">
                                  <span><strong>{{cellData.displayName}}: </strong></span> &nbsp;
                                  <mat-checkbox [checked]="row[cellData.columnName]" disabled></mat-checkbox>
                                </div>
                                <div *ngIf="!isMobile">
                                  <mat-checkbox [checked]="row[cellData.columnName]" disabled></mat-checkbox>
                                </div>
                              </ng-container>
                              <ng-container *ngSwitchDefault>
                                <div *ngIf="isMobile" fxLayout="row">
                                  <span><strong>{{ cellData.displayName }}: </strong></span> &nbsp;
                                  <span>{{ displayLimit(row[cellData.columnName], 13) }}</span>
                                </div>
                                <div *ngIf="!isMobile">
                                  {{displayLimit(row[cellData.columnName], cellData.size)}}
                                </div>
                              </ng-container>
                            </ng-container>
                          </mat-cell>
                        </ng-container>

                        <ng-container matColumnDef="actions">
                          <mat-header-cell *matHeaderCellDef fxFlex="10" [ngStyle]="isMobile ? {'width': '100%', 'padding-left': '2px'} : {}">Actions</mat-header-cell>
                          <mat-cell *matCellDef="let row" fxFlex="10" [ngStyle]="isMobile ? {'width': '100%', 'padding-left': '2px'} : {}">
                            <div *ngIf="isMobile" fxLayout="row" style="display: flex; justify-content: space-between; align-items: center;">
                              <span><strong>Actions: </strong></span>
                              <button mat-icon-button color="warn" aria-label="Delete Staff" (click)="deleteStaffAffiliation(row); $event.stopPropagation()">
                                <mat-icon>delete</mat-icon>
                              </button>
                              <button *ngIf="canTogglePocForStaffRow(row) && !row.isPOC" mat-icon-button color="primary" aria-label="Add Staff Member as a Point of Contact" (click)="updateStaffMemberPOCStatus(row); $event.stopPropagation()">
                                <mat-icon>person_add</mat-icon>
                              </button>
                              <button *ngIf="canTogglePocForStaffRow(row) && row.isPOC" mat-icon-button color="primary" aria-label="Remove Staff Member as a Point of Contact" (click)="updateStaffMemberPOCStatus(row); $event.stopPropagation()">
                                <mat-icon>person_remove</mat-icon>
                              </button>
                            </div>
                            <div *ngIf="!isMobile" fxLayout="row">
                              <button mat-icon-button color="warn" aria-label="Delete Staff" (click)="deleteStaffAffiliation(row); $event.stopPropagation()">
                                <mat-icon>delete</mat-icon>
                              </button>
                              <button *ngIf="canTogglePocForStaffRow(row) && !row.isPOC" mat-icon-button color="primary" aria-label="Add Staff Member as a Point of Contact" (click)="updateStaffMemberPOCStatus(row); $event.stopPropagation()">
                                <mat-icon>person_add</mat-icon>
                              </button>
                              <button *ngIf="canTogglePocForStaffRow(row) && row.isPOC" mat-icon-button color="primary" aria-label="Remove Staff Member as a Point of Contact" (click)="updateStaffMemberPOCStatus(row); $event.stopPropagation()">
                                <mat-icon>person_remove</mat-icon>
                              </button>
                            </div>
                          </mat-cell>
                        </ng-container>
                      </mat-table>

                      <br />
                      <mat-paginator [pageSize]="staffTablePageSize" [pageSizeOptions]="[5, 10, 50, firmFilteredStaff.length]" #StaffTablePaginator="matPaginator" showFirstLastButtons></mat-paginator>
                    </div>
                  </div>
                </mat-card-content>
              </mat-card>
            </ng-container>
          </mat-tab>

          <mat-tab>
            <ng-template mat-tab-label>
              <mat-icon>{{'manage_accounts'}}</mat-icon> User Accounts ({{userAccounts.length}})
            </ng-template>
            <ng-container>
              <mat-card class="custom-mat-card">
                <mat-card-title>
                  <div fxLayout="row">
                    <span>User Accounts</span>
                  </div>
                </mat-card-title>
                <mat-card-content>
                  <div fxLayout="column">
                    <div [fxFlex.gt-sm]="100" [fxFlex]="100" class="matero-col" style="overflow-x: auto;">
                      <div fxLayout="row wrap" class="matero-row" fxLayoutAlign="space-between start">
                        <div fxLayoutGap="5px">
                          <strong class="noMarginHeader">Results ({{userAccounts.length}})</strong>
                          <mat-form-field style="width:200px;">
                            <input (keyup)="applyUserAccountFilter($event)" placeholder="Filter Results" matInput />
                          </mat-form-field>
                        </div>
                      </div>

                      <br />

                      <mat-table [dataSource]="userAccountsDataSource" matSort #UserAccountTableSort="matSort" class="mat-elevation-z8" style="overflow-x: auto;">
                        <mat-header-row fxLayout="row" fxLayout.lt-md="column" *matHeaderRowDef="userAccountTable.layout.columns"></mat-header-row>
                        <mat-row fxLayout="row" fxLayout.lt-md="column" *matRowDef="let row; columns: userAccountTable.layout.columns" title="User Account" [ngClass]="getRowClass(row)"></mat-row>

                        <ng-container *ngFor="let cellData of userAccountTable.layout.container; let i = index" [matColumnDef]="cellData.columnName">
                          <mat-header-cell mat-sort-header [fxFlex]="cellData.size" *matHeaderCellDef>{{ cellData.displayName }}</mat-header-cell>
                          <mat-cell *matCellDef="let row" [fxFlex]="cellData.size" matTooltip="{{row[cellData.columnName]}}">
                            <ng-container [ngSwitch]="cellData.type">
                              <ng-container *ngSwitchCase="'date'">
                                {{ row[cellData.columnName] | date: 'MM/dd/yyyy' }}
                              </ng-container>
                              <ng-container *ngSwitchCase="'bool'">
                                <mat-checkbox [checked]="row[cellData.columnName]" disabled></mat-checkbox>
                              </ng-container>
                              <ng-container *ngSwitchDefault>
                                <ng-container *ngIf="cellData.columnName === 'lastUpdatedBy'">
                                  {{ shouldShowRequestedBy(row) ? displayLimit(row[cellData.columnName], cellData.size) : '' }}
                                </ng-container>
                                <ng-container *ngIf="cellData.columnName !== 'lastUpdatedBy'">
                                  {{ displayLimit(row[cellData.columnName], cellData.size) }}
                                </ng-container>
                              </ng-container>
                            </ng-container>
                          </mat-cell>
                        </ng-container>

                        <ng-container matColumnDef="actions">
                          <mat-header-cell *matHeaderCellDef fxFlex="7">Actions</mat-header-cell>
                          <mat-cell *matCellDef="let row" fxFlex="7">
                            <div style="display: flex; justify-content: space-between; width: 100px;">
                              <button mat-icon-button [color]="row.requestedStatus === 'Active' ? 'primary' : 'warn'" style="width: 50px;" (click)="toggleUserAccountRequestedStatus(row); $event.stopPropagation()" [title]="row.requestedStatus === 'Active' ? 'Request Deactivation' : 'Request Activation'">
                                <mat-icon>{{row.requestedStatus === 'Active' ? 'toggle_on' : 'toggle_off'}}</mat-icon>
                              </button>
                            </div>
                          </mat-cell>
                        </ng-container>
                      </mat-table>

                      <br />
                      <mat-paginator [pageSize]="userAccountTablePageSize" [pageSizeOptions]="[5, 10, 50, userAccountTable.layout.data.length]" #UserAccountTablePaginator="matPaginator" showFirstLastButtons></mat-paginator>
                    </div>
                  </div>
                </mat-card-content>
              </mat-card>
            </ng-container>
          </mat-tab>
        </mat-tab-group>
      </mat-card>
    </div>
  </div>

  <mat-card class="dialog-footer-card" [style.background-color]="uiData.firm.color">
    <button mat-raised-button color="primary" aria-label="Save" style="margin-right: 10px;" [disabled]="saving || !firmForm || !firmForm.valid" (click)="saveChanges()">
      {{ saving ? 'Saving...' : 'Save' }}
    </button>
    <button mat-raised-button aria-label="Exit" style="margin-right: 10px;" (click)="exitComponent()">
      {{ exitButtonLabel }}
    </button>
  </mat-card>
</div>
